import { Button } from "./button.tsx"
import { Loader2 } from "lucide-react"
import React from "react"

export function LoadingButton({ 
  children, 
  loading = false, 
  ...props 
}) {
  return (
    <Button {...props} disabled={loading || props.disabled}>
      {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
      {children}
    </Button>
  )
} 